import { CompanyProfileType, InvestorProfileType, UserProfileType } from '@/api/backend/types';
import { i18next } from '@/i18n';
import { AuthService } from '@/services/authService';
import { create } from 'zustand';

type AuthMethodType = 'email' | 'mobile';

type ClientIdType = 'eservice-portal' | 'civil-id-client';

const authMethodToClientId: Record<AuthMethodType, ClientIdType> = {
  email: 'eservice-portal',
  mobile: 'civil-id-client',
};

export type TAuthState = {
  userProfile: UserProfileType;
  authService: AuthService | null;
  activeProfile: CompanyProfileType | InvestorProfileType;
};

type TAuthActions = {
  setAuthService: (authMethod: AuthMethodType) => void;
  setUser: (user: UserProfileType) => void;
};

const clientId = localStorage.getItem(AuthService.CLIENT_ID_KEY);
const initialAuthState: TAuthState = {
  userProfile: {} as UserProfileType,
  authService: clientId ? new AuthService(clientId) : null,
  activeProfile: {} as CompanyProfileType | InvestorProfileType,
};

export const useAuthStore = create<TAuthState & TAuthActions>()((set) => ({
  ...initialAuthState,
  setAuthService: (authMethod) => {
    set({ authService: new AuthService(authMethodToClientId[authMethod]) });
  },
  setUser: (userProfile) => {
    const profileId = userProfile.activeProfileId;

    if (!profileId) return;

    const profile = userProfile.profiles.find((profile) => profile.id === profileId);
    if (!profile) return;

    // Set the language from the user's profile preference
    if (profile.languagePreference) {
      const language = profile.languagePreference.toLowerCase();
      if ((language === 'en' || language === 'ar') && localStorage.getItem('lang') == null) {
        i18next.changeLanguage(language);
      }
    }

    set({ userProfile, activeProfile: profile });
  },
}));
